import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { CLIENT_SETTINGS } from 'src/constants/EndpointUrls';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { SearchDetector, SearchFormPaginator } from 'src/components/index';
import AuditLogsTable from './AuditLogsTable';
import AuditLogsDateRangeForm from './AuditLogsDateRangeForm';
import LoadingView from 'src/components/LoadingView';

const AuditLogsList = props => {
  const {
    initialValues: formValues,
    location,
    searchAuditLogs,
    resetValues,
    isListLoading,
    reducerName,
    formName
  } = props
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <SearchDetector
        location={location}
        didMountDetectingJudger={() => true}
        willReceivePropsDetectingJudger={(prevProps, nextProps) => nextProps.location !== prevProps.location}
        onDetect={() => searchAuditLogs(formValues)}
      />
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">{t('features.AuditLogs.AuditLogsList.Operation_history_list')}</h1>
      </div>
      <div className="l-wrap-l l-contents-wrap">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('features.ClientAllowances.NewClientAllowance.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label={t('features.AuditLogs.AuditLogsList.Operation_history_list')} />
          </BreadCrumb>
        </div>
        <div className="l-wrap-xl">
          <AuditLogsDateRangeForm formName={formName} resetValues={resetValues} />
          <LoadingView isLoading={isListLoading}>
            <div className="u-mt20">
              <AuditLogsTable />
              <SearchFormPaginator formName={formName} reducerName={reducerName} />
            </div>
          </LoadingView>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AuditLogsList;
